import React from "react";
import {
  FaReact,
  FaVuejs,
  FaJs,
  FaHtml5,
  FaCss3Alt,
  FaNodeJs,
  FaDocker,
  FaGithub,
  FaGitAlt,
  FaPhp,
  FaLinux,
  FaTerminal,
} from "react-icons/fa";
import {
  SiTypescript,
  SiSymfony,
  SiBitbucket,
  SiRedux,
  SiFirebase,
  SiSass,
  SiMui,
  SiVim,
  SiPhpstorm,
  SiGithubcopilot,
  SiCursor,
  SiNextdotjs,
  SiTailwindcss,
  SiWebpack,
  SiGithubactions,
} from "react-icons/si";
import { VscGitMerge, VscVscode } from "react-icons/vsc";

const skillCategories = [
  {
    category: "Frontend",
    accent: "#e67a00",
    skills: [
      { name: "React.js", icon: FaReact },
      { name: "Next.js", icon: SiNextdotjs },
      { name: "Vue.js", icon: FaVuejs },
      { name: "TypeScript", icon: SiTypescript },
      { name: "JavaScript", icon: FaJs },
      { name: "HTML5", icon: FaHtml5 },
      { name: "CSS3 / Sass", icon: FaCss3Alt },
      { name: "Tailwind CSS", icon: SiTailwindcss },
      { name: "Webpack", icon: SiWebpack },
    ],
  },
  {
    category: "Backend",
    accent: "#3b82f6",
    skills: [
      { name: "PHP", icon: FaPhp },
      { name: "PHP Symfony", icon: SiSymfony },
      { name: "PHP Laminas", icon: FaPhp },
      { name: "Node.js", icon: FaNodeJs },
    ],
  },
  {
    category: "DevOps & CI/CD",
    accent: "#10b981",
    skills: [
      { name: "Docker", icon: FaDocker },
      { name: "CI / CD", icon: VscGitMerge },
      { name: "GitHub Actions", icon: SiGithubactions },
      { name: "Bitbucket Pipelines", icon: SiBitbucket },
      { name: "Git", icon: FaGitAlt },
    ],
  },
  {
    category: "Tools & Libraries",
    accent: "#8b5cf6",
    skills: [
      { name: "Redux", icon: SiRedux },
      { name: "Material-UI", icon: SiMui },
      { name: "Firebase", icon: SiFirebase },
      { name: "Sass / Gulp", icon: SiSass },
      { name: "GitHub", icon: FaGithub },
      { name: "Bitbucket", icon: SiBitbucket },
    ],
  },
  {
    category: "IDEs & Editors",
    accent: "#f59e0b",
    skills: [
      { name: "PhpStorm", icon: SiPhpstorm },
      { name: "VSCode", icon: VscVscode },
      { name: "Cursor", icon: SiCursor },
      { name: "Vim", icon: SiVim },
    ],
  },
  {
    category: "AI & Systems",
    accent: "#06b6d4",
    skills: [
      { name: "Cursor AI", icon: SiCursor },
      { name: "GitHub Copilot", icon: SiGithubcopilot },
      { name: "Linux", icon: FaLinux },
      { name: "Terminal / Bash", icon: FaTerminal },
    ],
  },
];

export default function Skills() {
  return (
    <section className="skills" id="skills">
      <div className="section__container">
        <div className="section__header">
          <span className="section__tag">What I work with</span>
          <h2 className="section__title">Skills</h2>
        </div>
        <div className="skills__grid">
          {skillCategories.map(({ category, accent, skills }) => (
            <div className="skills__category" key={category}>
              <div
                className="skills__category-header"
                style={{ borderBottomColor: accent }}
              >
                <span style={{ color: accent }}>{category}</span>
              </div>
              <div className="skills__list">
                {skills.map(({ name, icon: Icon }) => (
                  <div className="skills__item" key={name}>
                    <Icon style={{ color: accent }} />
                    <span>{name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
